// extracted by mini-css-extract-plugin
module.exports = {"container":"_6c97079b1b--container--IQDem","link":"_6c97079b1b--link--afoAE","mobile":"_6c97079b1b--mobile--UgVC_"};